<template>
	<h1 class="landing-title-move" data-typo-type="title" v-html="title"></h1>
</template>

<script>
export default {
	name: 'LandingTitleMove',
	props: {
		title: {
			type: String,
			required: true,
		},
	},
}
</script>

<style lang="scss" scoped>
.landing-title-move {
	// Move-лоадер: белый тайтл над фуллскрин-фото. Прогресс-блок опускается
	// вниз вьюпорт-относительным LandingComponentSpacer (см. order инстанса),
	// а НЕ фиксированным нижним отступом тайтла — иначе на коротких экранах
	// прогресс-бар уезжает за нижний край. Нижний отступ = 32px gap до спейсера
	// (Figma 18276:14533, gap-32).
	margin: var(--size-12) var(--size-32) var(--size-32);
	text-align: center;

	// Web/Heading/Title 2 (Figma 18746): 24/28, 700
	font-size: var(--size-24);
	line-height: var(--size-28);
	font-weight: 700;

	color: var(--Text-White-100);
}
</style>
